// extracted by mini-css-extract-plugin
module.exports = {"container":"deckCardWrapper_container__PGeKO"};